import { useController } from 'react-hook-form';
import { ALIGNMENT } from 'ui/selects';
import { TimeZonePicker, TimeZonePickerProps } from 'ui/datePicker';
import { FieldProps } from './types';

type TimeZoneSelectProps = {
  verticalAlignment?: ALIGNMENT;
};

type TimeZonePickerFieldProps = FieldProps &
  TimeZoneSelectProps &
  Omit<TimeZonePickerProps, 'timeZone' | 'onTimeZoneChange'>;

export const TimeZonePickerField = ({ name, defaultValue, ...props }: TimeZonePickerFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue,
  });

  return (
    <TimeZonePicker {...props} timeZone={value} onTimeZoneChange={([time]) => onChange(time)} />
  );
};
